
import { useSnapshot } from "valtio"
import { contractsStore } from "../state/CommonState"
import Utils from "../util/Utils"
import FCLScheduleComp from "./FCLScheduleComp"
import LCLScheduleComp from "./LCLScheduleComp"

export default function LCLSchedules(props) {
    useSnapshot(contractsStore)
    const cargoList = contractsStore.current.cargoList
    const rec = contractsStore.current
    if (!rec || rec === {}) return <></>
    let data = [...props.data]
    data.sort((o1,o2) => {
        if (o1.oetd) {
            return Utils.compareDates(o1.oetd, o2.oetd)
        }
        return Utils.compareDates(o1['ETD (POL)'], o2['ETD (POL)'])
    })
    return (
        <>
            <div style={{ boxShadow: '5px 5px #dddddd', border: '1px solid lightgrey' }}>
                <div className="card-content" style={{ paddingTop: '0px' }}>
                    <div className="content">
                        {
                            data.map(e => {
                                if (rec.shipmentType.startsWith('LCL'))
                                    return <LCLScheduleComp data={e} />
                                else if (rec.shipmentType.startsWith('FCL'))
                                    return <FCLScheduleComp data={e} />
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    )
}